var _a;
import { generatePromises } from "../generators/generator.promises";
import { GENERATOR_PARAMS } from "./scheduledExport.constants";
export var getPaged = (_a = generatePromises(GENERATOR_PARAMS), _a.getPaged), create = _a.create, update = _a.update, remove = _a.remove;
